module.exports = __webpack_public_path__ + "img/img2.7259c12b.jpg";